import React, { Component } from "react";
import ModalHead from "./../components/modal-head/modalHead";
import PrimaryButton from "../components/utils/primaryButton";

import $ from "jquery";
import swal from "sweetalert";
import Journey from "../components/journey/journey";
import CalendarImg from "../assets/images/calender_org.png";

import { DataService } from "./../services/data.service";
import moment from "moment";

import * as handler from "../components/utils/handler";
import RefreshButton from "../components/utils/refreshButton";
import DangerButton from "../components/utils/dangerButton";
// import RefreshButton from "./../components/utils/refreshButton";
import IconButton from "./../components/utils/iconButton";

const queryString = require("query-string");

class CheckIn extends Component {
  color = window["app-config"].ui.checkInScreen;
  defaultLanguage = window["app-config"].defaultLang;
  divideBy = window["app-config"].divideBy;
  checkInIssueTicket = window["app-config"].checkInIssueTicket;
  defaultPhoneNumberPrefix = window["app-config"].defaultPhoneNumberPrefix;
  issueTicketEnabled = window["app-config"].issueTicketEnabled;
  URL = window["app-config"].URL;
  whatsappUrl = window["app-config"].whatsappUrl;
  icons = window["app-config"].ui.icons;
  refreshInterval = window["app-config"].applicationProperties.refreshInterval;
  popupExpiry = window["app-config"].ui.popupExpiry;
  userDetailsConfig = window["app-config"].userDetails;
  enableSurnameField = window["app-config"].enableSurnameField;

  state = {
    isSuccessfullyCheckedIn: false,
    lang: {},
    appointmentNumber: null,
    phoneNumber: this.defaultPhoneNumberPrefix,
    emailAddress: null,
    branchIp: null,
    dataLoaded: true,
    verifyAppointmentResponse: "",
    issueTicketResponse: null,
    enableCheckInButton: false,
    whatsappUrl: window["app-config"].URL.whatsappUrl,
    redirectUrl: "",
    isTicketCalled: false,
  };

  isValidAppointmentNumber = false;
  isValidEmail = false;
  isValidPhoneNumber = false;

  service = new DataService();
  phoneNumRef = React.createRef();

  componentDidMount() {
    handler.blinkText(".blink");
    if (this.state.isTicketCalled) {
      handler.notify();
    }
    this.setState({
      redirectUrl: handler.removeKeyFromUrl("checkin", "appointmentnumber"),
    });

    if (
      localStorage.getItem("checkedIn") === "true" &&
      localStorage.getItem("checkedInDate") == moment().toDate().toDateString()
    ) {
      this.setState(JSON.parse(localStorage.getItem("prevCheckedInData")));
      setInterval(() => {
        this.getTicketStatus();
      }, this.refreshInterval);

      handler.onBrowserReload(this.getTicketStatus);
    } else {
      localStorage.removeItem("checkedIn");
      localStorage.removeItem("checkedInDate");
      localStorage.removeItem("prevCheckedInData");
      this.setState({ lang: handler.setTranslations() });
      let appointmentNumber = queryString.parse(window.location.search)
        .appointmentnumber;
      let email = "";
      let phoneNumber = "";
      let branchIp = queryString.parse(window.location.search).branchip;

      if (branchIp !== undefined) {
        this.setState({ branchIp });
      }

      if (appointmentNumber !== undefined && appointmentNumber !== "") {
        this.verifyAppointmentInfo(
          email,
          phoneNumber,
          appointmentNumber,
          branchIp === undefined ? "" : branchIp
        );
      }
    }
  }

  generateUrl = (branchCode, ticketId) => {
    let whatsappUrl = `${this.URL.whatsappUrl}&text=${branchCode}%20${ticketId}`;
    this.setState({ whatsappUrl: whatsappUrl });
  };

  /* EVENTS*/
  validateEmail(email) {
    var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    return emailReg.test(email);
  }

  onCheckInClick = () => {
    $(document).ready(function () {
      $("button").css("background-color", "#000");
    });
    this.verifyAppointmentInfo(
      this.state.emailAddress === null ? "" : this.state.emailAddress,
      this.state.phoneNumber !== undefined && this.state.phoneNumber.length > 3
        ? this.state.phoneNumber.replace("+", "%2b")
        : "",

      this.state.appointmentNumber === null ? "" : this.state.appointmentNumber,
      this.state.branchIp === null ? "" : this.state.branchIp
    );
  };

  onTextFieldsChange = (e) => {
    var appointmentNumber = null;
    var phoneNumber = null;
    var email = null;
    if (e.target.id === "appointmentNumber") {
      if (e.target.value.length > 0 && e.target.value !== "") {
        this.isValidAppointmentNumber = true;
        appointmentNumber = e.target.value;
        this.setState({
          appointmentNumber: e.target.value,
        });
      } else {
        this.isValidAppointmentNumber = false;
      }
    } else if (e.target.id === "phoneNumber") {
      if (
        (e.target.value.length === 0 && e.target.value === "") ||
        e.target.value.length <
          this.userDetailsConfig.phoneNumberField.minLength ||
        /\s/.test(e.target.value) ||
        !e.target.value.charAt(0).includes("+") ||
        !/^[0-9+]+$/.test(e.target.value)
      ) {
        $("#phoneNumber").css("border-color", "red");
        this.isValidPhoneNumber = false;
      } else {
        this.isValidPhoneNumber = true;

        $("#phoneNumber").css("border-color", "#dadada");
        this.phoneNumber = this.phoneNumRef.current.value;
      }
      phoneNumber = e.target.value;
      this.setState({ phoneNumber: e.target.value });
    } else if (e.target.id === "emailAddress") {
      if (
        !this.validateEmail(e.target.value) ||
        /^([\w-\.]+([\w-]+\.)+[\w-]{2,4})?$/.test(e.target.value)
      ) {
        $("#emailAddress").css("border-color", "red");
        this.isValidEmail = false;
      } else {
        $("#emailAddress").css("border-color", "#dadada");
        this.isValidEmail = true;

        this.setState({
          emailAddress: e.target.value,
        });
      }
    }

    if (
      this.isValidEmail === false &&
      this.isValidAppointmentNumber === false &&
      this.isValidPhoneNumber === false
    ) {
      this.setState({
        enableCheckInButton: false,
      });
    } else {
      this.setState({
        enableCheckInButton: true,
      });
    }
  };

  /*API METHODS*/

  verifyAppointmentInfo = async (
    email,
    phoneNumber,
    appointmentNumber,
    branchIp
  ) => {
    this.setState({ dataLoaded: false });
    try {
      let verifyAppointmentResponse = await this.service.verifyAppointmentInfo(
        email,
        phoneNumber,
        appointmentNumber,
        branchIp
      );
      console.log("VERIFY APPOINTMENT RESPONSE: ", verifyAppointmentResponse);
      if (
        verifyAppointmentResponse.data.error !== undefined &&
        verifyAppointmentResponse.data.error === true
      ) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else if (
        verifyAppointmentResponse.data.split("|")[0] === "100" &&
        this.checkInIssueTicket === true &&
        verifyAppointmentResponse.data.split("|")[14] === "ON_TIME"
        // verifyAppointmentResponse.data.split("|")[14] === "EARLY"
      ) {
        this.setState({
          verifyAppointmentResponse,
          dataLoaded: true,
        });

        this.issueTicket();
      } else if (
        (verifyAppointmentResponse.data.split("|")[0] === "100" || verifyAppointmentResponse.data.split("|")[0] === "106") &&
        this.checkInIssueTicket === true &&
        verifyAppointmentResponse.data.split("|")[14] === "EARLY"
      ) {
        this.setState({ dataLoaded: true });

        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.EarlyIssueTicket,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else if (
        verifyAppointmentResponse.data.split("|")[0] === "100" &&
        this.checkInIssueTicket === true &&
        verifyAppointmentResponse.data.split("|")[14] === "LATE"
      ) {
        this.setState({ dataLoaded: true });

        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.LateIssueTicket,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else if (
        verifyAppointmentResponse.data.split("|")[0] === "100" &&
        this.checkInIssueTicket === false
      ) {
        this.setState({ dataLoaded: true });
        handler.showSuccessMessage(
          this.state.lang.AppointmentIsValid,
          this.state.lang.Ok
        );
      } else if (
        verifyAppointmentResponse.data.split("|")[0] === "103" &&
        verifyAppointmentResponse.data.split("|")[16] === "TICKET_ISSUED" &&
        this.checkInIssueTicket === true
      ) {
        this.setState({ dataLoaded: true });

        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.TicketAlreadyIssued,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else if (verifyAppointmentResponse.data.split("|")[0] === "101") {
        this.setState({ dataLoaded: true });

        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.AppointmentNotFound,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      }
      this.setState({ dataLoaded: true });
      console.log("ERROR IN VERIFY APPOINTMENT", error.message);
    }
  };

  issueTicket = async () => {
    this.setState({ dataLoaded: false });
    if (this.state.verifyAppointmentResponse.data.split("|")[0] === "100") {
      try {
        let branchId = this.state.verifyAppointmentResponse.data.split("|")[3];
        let branchCode = this.state.verifyAppointmentResponse.data.split(
          "|"
        )[29];
        let categoryId = this.state.verifyAppointmentResponse.data.split(
          "|"
        )[4];
        let priority = this.state.verifyAppointmentResponse.data.split("|")[5];
        let emailAddress = this.state.verifyAppointmentResponse.data.split(
          "|"
        )[7];
        let phoneNumber = this.state.verifyAppointmentResponse.data.split(
          "|"
        )[18];
        let escapedPhoneNumber = phoneNumber.replace("+", "%2b");
        let firstName =this.enableSurnameField == true ? this.state.verifyAppointmentResponse.data.split("|")[26] : this.state.verifyAppointmentResponse.data.split(
          "|"
        )[33];
        let additionalInformation = this.state.verifyAppointmentResponse.data.split(
          "|"
        )[25];
        let surName = this.enableSurnameField ? this.state.verifyAppointmentResponse.data.split("|")[27]:""  ;
        let status = this.state.verifyAppointmentResponse.data.split("|")[14];
console.log("data",surName,firstName);
console.log("data",this.state.verifyAppointmentResponse.data);
        let issueTicketResponse = await this.service.issueTicket(
          branchId,
          categoryId,
          priority,
          emailAddress,
          3,
          localStorage.getItem("lang") === "es"
            ? "Sp"
            : localStorage.getItem("lang"),
          firstName + "%20" + surName,
          escapedPhoneNumber,
          emailAddress,
          "1",
          additionalInformation
        );
        console.log("RESPONSE OF ISSUE TICKET : ", issueTicketResponse);

        if (
          issueTicketResponse.data.error !== undefined &&
          issueTicketResponse.data.error === true
        ) {
          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok,
            this.state.redirectUrl
          );
          this.setState({ dataLoaded: true });
        } else if (
          issueTicketResponse.data.ticket_info !== undefined &&
          issueTicketResponse.data.ticket_info !== null
        ) {
          let heading = this.state.lang.YourTicketHasBeenIssued;
          this.setState({
            issueTicketResponse: issueTicketResponse,
            isSuccessfullyCheckedIn: true,
            heading,
            dataLoaded: true,
          });
          localStorage.setItem("checkedIn", true);
          localStorage.setItem("prevCheckedInData", JSON.stringify(this.state));
          localStorage.setItem(
            "checkedInDate",
            moment().toDate().toDateString()
          );
          this.generateUrl(
            branchCode,
            issueTicketResponse.data.ticket_info.ticket_id
          );
          this.markAppointmentUsed();
          // setInterval(() => {
          //   this.getTicketStatus();
          // }, this.refreshInterval);
        } else if (issueTicketResponse.data.resp_status === "-1") {
          this.setState({ isSuccessfullyCheckedIn: false, dataLoaded: true });

          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.TicketNotIssued,
            this.state.lang.Ok,
            this.state.redirectUrl
          );
        } else if (
          issueTicketResponse.data.resp_message ===
          "You already have an issued ticket for the category, in the branch."
        ) {
          this.setState({ isSuccessfullyCheckedIn: false, dataLoaded: true });

          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.TicketAlreadyIssued,
            this.state.lang.Ok,
            this.state.redirectUrl
          );
        }
      } catch (error) {
        if (error.message.includes("timeout")) {
          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.ServerNotResponding,
            this.state.lang.Ok,
            this.state.redirectUrl
          );
          this.setState({ dataLoaded: true });
        } else if (error.message.includes("404")) {
          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.UrlNotFound,
            this.state.lang.Ok,
            this.state.redirectUrl
          );
          this.setState({ dataLoaded: true });
        } else if (error.message.includes("Network Error")) {
          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.InternetConnectionError,
            this.state.lang.Ok,
            this.state.redirectUrl
          );
          this.setState({ dataLoaded: true });
        } else {
          handler.showErrMsg(
            this.state.lang.Error,
            this.state.lang.SomeThingWentWrong,
            this.state.lang.Ok,
            this.state.redirectUrl
          );
          this.setState({ dataLoaded: true });
        }

        console.log("ERROR IN ISSUE TICKET ", error.message);
      }
    }
  };

  cancelTicket = async () => {
    swal(
      this.state.lang.CancelTicketConfirmation,

      {
        icon: "warning",
        buttons: {
          no: {
            text: this.state.lang.No === undefined ? "No" : this.state.lang.No,
            value: "no",
          },
          yes: {
            text:
              this.state.lang.Yes === undefined ? "Yes" : this.state.lang.Yes,
            value: "yes",
            closeModal: false,
          },
        },
      }
    ).then(async (value) => {
      switch (value) {
        case "yes":
          let branchId = this.state.verifyAppointmentResponse.data.split(
            "|"
          )[3];
          let ticketId = this.state.issueTicketResponse.data.ticket_info
            .ticket_id;
          let ticketNumber = this.state.issueTicketResponse.data.ticket_info
            .ticket_no;
          let sqn = this.state.issueTicketResponse.data.ticket_info.categoryid;
          let emailAddress = this.state.verifyAppointmentResponse.data.split(
            "|"
          )[7];
          let phoneNumber = this.state.verifyAppointmentResponse.data.split(
            "|"
          )[18];
          let language =
            localStorage.getItem("lang") === "es"
              ? "Sp"
              : localStorage.getItem("lang");
          try {
            let cancelTicketResponse = await this.service.cancelTicket(
              emailAddress,
              ticketId,
              branchId,
              language,
              ticketNumber,
              sqn,
              phoneNumber
            );
            console.log("CANCEL TICKET RESPONSE: ", cancelTicketResponse);
            if (cancelTicketResponse.data.resp_message === "Ticket cancelled") {
              swal.close();

              localStorage.removeItem("checkedIn");
              localStorage.removeItem("checkedInDate");
              localStorage.removeItem("prevCheckedInData");

              handler.redirect(this.state.redirectUrl);
            } else if (
              cancelTicketResponse.data.resp_message === "Ticket not found" ||
              cancelTicketResponse.data.resp_message ===
                "Operation not permitted"
            ) {
              handler.showErrMsg(
                this.state.lang.Error,
                this.state.lang.TicketNotFound,
                this.state.lang.Ok,
                this.state.redirectUrl
              );
              localStorage.removeItem("checkedIn");
              localStorage.removeItem("checkedInDate");
              localStorage.removeItem("prevCheckedInData");
              handler.redirect(this.state.redirectUrl);
            } else {
              handler.showErrMsg(
                this.state.lang.Error,
                this.state.lang.SomeThingWentWrong,
                this.state.lang.Ok,
                this.state.redirectUrl
              );
            }
          } catch (error) {
            if (error.message.includes("404")) {
              handler.showErrMsg(
                this.state.lang.Error,
                this.state.lang.UrlNotFound,
                this.state.lang.Ok,
                this.state.redirectUrl
              );
            } else if (error.message.includes("Network Error")) {
              handler.showErrMsg(
                this.state.lang.Error,
                this.state.lang.InternetConnectionError,
                this.state.lang.Ok,
                this.state.redirectUrl
              );
            }
          }

          break;
        case "no":
          break;

        default:
      }
    });
  };

  markAppointmentUsed = async () => {
    try {
      let appointmentNumber = this.state.verifyAppointmentResponse.data.split(
        "|"
      )[2];
      let emailAddress = this.state.verifyAppointmentResponse.data.split(
        "|"
      )[7];

      let ticketNumber = this.state.issueTicketResponse.data.ticket_info
        .ticket_no;
      let response = await this.service.markAppointmentUsedAfterTicketIssue(
        appointmentNumber,
        emailAddress,
        ticketNumber
      );
      if (response.data.error !== undefined && response.data.error === true) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.ServerNotResponding,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else if (error.message.includes("404")) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.UrlNotFound,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else if (error.message.includes("Network Error")) {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.InternetConnectionError,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      } else {
        handler.showErrMsg(
          this.state.lang.Error,
          this.state.lang.SomeThingWentWrong,
          this.state.lang.Ok,
          this.state.redirectUrl
        );
      }
      console.log("ERROR IN MARKING APPOINTMENT USED: ", error.message);
    }
  };

  getTicketStatus = async () => {
    let prevState = JSON.parse(localStorage.getItem("prevCheckedInData"));
    let branchId = prevState.verifyAppointmentResponse.data.split("|")[3];
    let categoryId = prevState.verifyAppointmentResponse.data.split("|")[4];
    let ticketId = prevState.issueTicketResponse.data.ticket_info.ticket_id;
    let ticketNumber = prevState.issueTicketResponse.data.ticket_info.ticket_no;
    try {
      let response = await this.service.getTicketStatus(
        branchId,
        ticketId,
        ticketNumber,
        categoryId
      );
      if (response.data.error !== undefined && response.data.error) {
        handler.showErrMsg(
          prevState.lang.Error,
          prevState.lang.ServerNotResponding,
          prevState.lang.Ok,
          prevState.redirectUrl
        );
      } else {
        if (response.data.resp_status === 1) {
          let issueTicketResponse = {
            ...prevState.issueTicketResponse,
          };
          issueTicketResponse["data"]["ticket_info"][
            "category_approx_waittime"
          ] = response.data.est_wait_time;
          issueTicketResponse["data"]["ticket_info"]["ticket_in_wait"] =
            response.data.position_in_queue <= 0
              ? 0
              : parseInt(response.data.position_in_queue);
          this.setState({ issueTicketResponse: issueTicketResponse });
          localStorage.setItem("prevCheckedInData", JSON.stringify(prevState));
        } else if (response.data.resp_status === 2) {
          handler.notify();
          this.setState({ isTicketCalled: true });
        } else if (response.data.resp_status === 3) {
          localStorage.clear();
          handler.showErrMsg(
            prevState.lang.Error,
            prevState.lang.TicketNotFound,
            prevState.lang.Ok,
            prevState.redirectUrl
          );
          setTimeout(() => {
            localStorage.clear();
            handler.redirect(prevState.redirectUrl);
          }, this.popupExpiry);
        }
      }
    } catch (error) {
      if (error.message.includes("timeout")) {
        handler.showErrMsg(
          prevState.lang.Error,
          prevState.lang.ServerNotResponding,
          prevState.lang.Ok,
          prevState.redirectUrl
        );
      } else {
        handler.showErrMsg(
          prevState.lang.Error,
          prevState.lang.SomeThingWentWrong,
          prevState.lang.Ok,
          prevState.redirectUrl
        );
        console.log(error.message);
      }
    }
  };

  // START OF REDNERING JSX

  getTicketNumber = () => {
    if (
      this.state.issueTicketResponse.data.ticket_info !== undefined &&
      this.state.issueTicketResponse.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-date">
          <div className="booking-summary-details">
            <p
              className="sameTextColor"
              style={{ fontSize: "30px", color: this.color.labelColor }}
            >
              {this.state.lang.TicketNumber}
            </p>
          </div>
          <p
            className="sameFont "
            style={{
              fontSize: "56px",
              fontWeight: "bold",
              color: "#000",
            }}
          >
            <strong
              className={
                this.state.isTicketCalled
                  ? "blink sameHeads sameTextColor"
                  : "sameHeads sameTextColor"
              }
              style={{
                position: "absolute",
                marginLeft: "-80px",
              }}
            >
              {this.state.issueTicketResponse.data.ticket_info.ticket_no}
            </strong>
          </p>
          <br />
          <br />
          <br />
          <br />
        </div>
      );
    }
  };

  getTotalWaitingTime = () => {
    let waitTime = Math.floor(
      this.state.issueTicketResponse.data.ticket_info.category_approx_waittime /
        60
    );

    if (
      this.state.issueTicketResponse.data.ticket_info !== undefined &&
      this.state.issueTicketResponse.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-wait">
          <p className="sameFont">
            {`${this.state.lang.EstimatedWaitTimeMessage} ${waitTime} ${this.state.lang.Minutes}`}
          </p>
        </div>
      );
    }
  };

  getTicketIssuedDateTime = () => {
    if (
      this.state.issueTicketResponse.data.ticket_info !== undefined &&
      this.state.issueTicketResponse.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-wait">
          <strong
            className="sameHeads"
            style={{ color: this.color.labelColor }}
          >
            {this.state.lang.TicketIssuedTime}
          </strong>
          <p className="sameFont">
            {/* {this.state.issueTicketResponse.data.ticket_info.issued_on} */}
            {moment(
              this.state.issueTicketResponse.data.ticket_info.issued_on
            ).format("DD-MMM-YYYY hh:mm A")}
          </p>
        </div>
      );
    }
  };

  getTicketsWaiting = () => {
    if (
      this.state.issueTicketResponse.data.ticket_info !== undefined &&
      this.state.issueTicketResponse.data.ticket_info !== null
    ) {
      return (
        <div className="booking-summary-wait">
          {/* <strong
            className="sameHeads"
            style={{ color: this.color.labelColor }}
          >
            {this.state.lang.TicketInWait}
          </strong> */}
          <p className="sameFont">
            {`${this.state.lang.ThereArePeople} ${this.state.issueTicketResponse.data.ticket_info.ticket_in_wait} ${this.state.lang.TicketInWait}`}
          </p>
        </div>
      );
    }
  };

  // END OF REDNERING JSX

  render() {
    return (
      <div className="container">
        <div className="sl__modal">
          <ModalHead heading={this.state.lang.CheckIn} />
          {this.state.isSuccessfullyCheckedIn === false ? (
            <div className="sl__modal-inner">
              <div className="sl__modal--content">
                <div className="sl__modal--row">
                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label checkInFieldslbl"
                      style={{ color: this.color.labelColor }}
                    >
                      {this.state.lang.AppointmentNumber}
                    </label>
                    <input
                      type="text"
                      name="Appointment Number"
                      maxLength={20}
                      onChange={this.onTextFieldsChange}
                      placeholder={this.state.lang.AppointmentNumber}
                      id="appointmentNumber"
                      className="sl__modal_form--input validate-text  checkInFields"
                    />
                  </div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label checkInFieldslbl"
                      style={{ color: this.color.labelColor }}
                    >
                      {this.state.lang.PhoneNumberPlaceholder}
                    </label>

                    <input
                      onChange={this.onTextFieldsChange}
                      type="text"
                      name="phone"
                      value={this.state.phoneNumber}
                      placeholder={this.state.lang.PhoneNumberPlaceholder}
                      id="phoneNumber"
                      maxLength={
                        this.userDetailsConfig.phoneNumberField.maxLength
                      }
                      ref={this.phoneNumRef}
                      className="sl__modal_form--input validate-num checkInFields"
                    />
                  </div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label checkInFieldslbl"
                      style={{ color: this.color.labelColor }}
                    >
                      {this.state.lang.EmailAddressPlaceHolder}
                      {/* <span className="estaric">*</span> */}
                    </label>
                    <input
                      type="text"
                      name="Email Address"
                      onChange={this.onTextFieldsChange}
                      placeholder={this.state.lang.EmailAddressPlaceHolder}
                      id="emailAddress"
                      className="sl__modal_form--input validate-text  checkInFields"
                    />
                  </div>

                  {this.state.enableCheckInButton === true ? (
                    <PrimaryButton
                      onClick={this.onCheckInClick}
                      bgColor={this.color.btnColor}
                    >
                      {this.state.dataLoaded === false ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : null}{" "}
                      &nbsp;
                      {this.state.lang.CheckIn}
                    </PrimaryButton>
                  ) : null}
                </div>
              </div>
            </div>
          ) : null}

          {this.state.isSuccessfullyCheckedIn === true ? (
            <div className="sl__modal-inner confirmed">
              <div className="sl__modal--content">
                <div className="buttons">
                  <RefreshButton
                    onClick={this.getTicketStatus}
                    color={this.color.btnColor}
                  />
                </div>
                <h2 style={{ color: this.color.fColorm, padding: "30px" }}>
                  {this.state.lang.IssueTicketConfirmedMessage}
                </h2>

                <div className="booking-summary-subject ">
                  {this.getTotalWaitingTime()}
                </div>

                <div className="booking-summary-subject ">
                  {this.getTicketsWaiting()}
                </div>

                <Journey
                  position={parseInt(
                    this.state.issueTicketResponse.data.ticket_info
                      .ticket_in_wait
                  )}
                ></Journey>
                <div className="booking-summary-bookingref">
                  {this.getTicketNumber()}
                </div>

                <div className="sl__modal_form-col">
                  <div className="booking-summary-subject ">
                    {this.getTicketIssuedDateTime()}
                  </div>
                </div>

                {this.color.enableWhatsappButton ? (
                  <div className="booking-summary-bookingref">
                    <IconButton
                      icon={
                        process.env.PUBLIC_URL +
                        `/images/${this.icons.whatsapp}`
                      }
                      onClick={this.state.whatsappUrl}
                      backgroundColor={this.color.iconBtns.backgroundColor}
                      fontColor={this.color.iconBtns.fontColor}
                      borderColor={this.color.iconBtns.borderColor}
                      text={this.state.lang.Whatsapp}
                      disabled={this.state.isTicketCalled}
                      disabledColor={this.color.iconBtns.disabledColor}
                    />
                  </div>
                ) : null}
              </div>

              <div
                className="btns"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  marginTop: "-10px",
                }}
              >
                <DangerButton
                  text={this.state.lang.ModifyOrCancelTicket}
                  onClick={this.cancelTicket}
                  color={this.color.cancelTicketBtn}
                  disabled={this.state.isTicketCalled}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default CheckIn;
